import React from "react";

export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/images/logo.png"
    alt="INRISOFT"
    width={size}
    height={size}
    className={`rounded-sm object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);

export const Logo = ({ onClick, size = 40 }) => (
  <a
    href="#home"
    onClick={onClick}
    data-testid="logo-link"
    className="flex items-center gap-3 group select-none"
    aria-label="INRISOFT home"
  >
    <LogoMark size={size} className="transition-transform duration-500 group-hover:rotate-[-6deg]" />
  </a>
);

export default Logo;
